<template>
<div class="chapter">
<div class="inner_page">
<section class="Basic-Text-Frame" epub:type="chapter" id="_idContainer009" role="doc-chapter">
<p class="ch-part">BOOK ONE</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Book_One.vue?8969e33c